import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

type MobileMenuContextType = {
  isMenuOpen: boolean;
  setIsMenuOpen: (isOpen: boolean) => void;
};

const MobileMenuContext = createContext<MobileMenuContextType>({
  isMenuOpen: false,
  setIsMenuOpen: () => {},
});

export const MobileMenuProvider = ({
  children,
}: { children: React.ReactNode }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleSetIsMenuOpen = useCallback((isOpen: boolean) => {
    setIsMenuOpen(isOpen);
  }, []);

  const value = useMemo(
    () => ({
      isMenuOpen,
      setIsMenuOpen: handleSetIsMenuOpen,
    }),
    [isMenuOpen, handleSetIsMenuOpen],
  );

  return (
    <MobileMenuContext.Provider value={value}>
      {children}
    </MobileMenuContext.Provider>
  );
};

export const useMobileMenu = () => useContext(MobileMenuContext);
